import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Table, TableBody, TableCell, TableHead, TableRow, useMediaQuery, useTheme } from '@mui/material';
import React, { memo, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Header from '../../../components/Header';
import AddIcon from '@mui/icons-material/Add';
import { useDispatch, useSelector } from 'react-redux';
import { deleteBom, getBom, getcategoryBom, getproductBom, getsubcategoryBom } from '../../../redux/slice/bom.slice';
import EditIcon from '@mui/icons-material/Edit';
import { tokens } from '../../../theme';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import DeleteIcon from '@mui/icons-material/Delete';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';

const BomDataGrid = memo(({ data, columns }) => {
    return (
        <DataGrid
            rows={data}
            columns={columns}
            components={{ Toolbar: GridToolbar }}
            pageSize={5}
            rowsPerPageOptions={[5, 10]}
            getRowId={(row) => row._id}
            autoHeight
            density="compact"
            sx={{
                "@media print": {
                    "& .MuiDataGrid-toolbarContainer": {
                        display: "none !important"
                    },
                    "& .MuiDataGrid-root": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-cell": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-footerContainer": {
                        color: "black !important",
                    },
                    "& .css-7ms3qr-MuiTablePagination-displayedRows": {
                        color: "black !important",
                    },
                },
            }}
        />
    )
});

const BillofMaterial = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const BOM = useSelector(state => state.bom.Bom)
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isMobile = useMediaQuery('(max-width:500px)');
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [DeleteBom, setDeleteBom] = useState(null);
    const categories = useSelector(state => state.bom.category);
    const subcategories = useSelector(state => state.bom.subCategory);
    const productData = useSelector(state => state.bom.products)

    useEffect(() => {
        dispatch(getBom())
        dispatch(getcategoryBom())
        dispatch(getsubcategoryBom())
        dispatch(getproductBom())
    }, [])

    const handleAddBOM = () => {
        navigate('/admin/add-bom');
    }

    const handleEdit = (data) => {
        navigate('/admin/add-bom', { state: data })
    }

    const handleDelete = (id) => {
        setDeleteBom(id)
        setDeleteConfirmOpen(true)
    }

    const confirmDelete = () => {
        if (DeleteBom) {
            dispatch(deleteBom(DeleteBom));
            setDeleteConfirmOpen(false);
            setDeleteBom(null);
        }
    }
    const cancelDelete = () => {
        setDeleteConfirmOpen(false);
        setDeleteBom(null);
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }

    const [openDialog, setOpenDialog] = useState(false);
    const [selectedBomDetails, setSelectedBomDetails] = useState([]);

    const handleView = (details) => {
        setSelectedBomDetails(details);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setSelectedBomDetails(null);
    };

    const columns = useMemo(() => [
        {
            field: 'Date',
            headerName: 'Date',
            width: 200,
            valueFormatter: (params) => formatDate(params.value)
        },
        {
            field: 'BOMName', headerName: 'BOM Name', width: 200,
        },
        {
            field: 'systemSize', headerName: 'system size', width: 200,
        },
        {
            field: 'TotalAmount', headerName: 'Total Amount', width: 200,
        },
        {
            field: 'PriceAfterSubcidy', headerName: 'Price After Subcidy', width: 200,
        },
        {
            field: 'Action',
            headerName: 'Action',
            width: 130,
            renderCell: (params) => {
                return (
                    <>
                        <IconButton aria-label="view" onClick={() => handleView(params.row)}>
                            <RemoveRedEyeIcon />
                        </IconButton>
                        <IconButton aria-label="edit" onClick={() => handleEdit(params.row)}>
                            <EditIcon />
                        </IconButton>
                        <IconButton aria-label="delete" onClick={() => handleDelete(params.row._id)}>
                            <DeleteIcon />
                        </IconButton>
                    </>
                );
            }
        },
    ], []);

    return (
        <Box m="2px">
            <Header
                title="BILL OF MATERIAL"
                subtitle="Manage Your Bill of Material Here"
            />
            <Box display="flex" justifyContent="flex-end" mb={2}>
                <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleAddBOM}>
                    Add Bill of Material
                </Button>
            </Box>

            <Box
                height="75vh"
                sx={useMemo(() => ({
                    "& .MuiDataGrid-root": {
                        border: "none",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[700],
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[700],
                    },
                    "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                        color: `${colors.grey[100]} !important`,
                        fontSize: "13px !important"
                    },
                }), [colors])}
            >
                <BomDataGrid data={BOM} columns={columns} />
            </Box>



            <Dialog open={deleteConfirmOpen} onClose={cancelDelete}>
                <DialogContent>
                    Are you sure you want to delete this Bill of Material?
                </DialogContent>
                <DialogActions>
                    <Button onClick={cancelDelete} style={{ color: theme.palette.text.primary }}>No</Button>
                    <Button onClick={confirmDelete} style={{ color: theme.palette.text.primary }}>Yes</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth={"sm"}
                fullWidth>
                <DialogTitle textAlign={'center'}>BOM Details</DialogTitle>
                <DialogContent>
                    <div style={{ display: 'flex', color: theme.palette.text.primary }}>
                        <ul style={{ listStyle: 'none', padding: 0 }}>
                            <li>Name</li>
                            <li>System Size </li>
                            <li>Date </li>
                            <li>Types Of Project </li>
                        </ul>
                        <ul style={{ listStyle: 'none' }}>
                            <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{selectedBomDetails?.BOMName}</li>
                            <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{selectedBomDetails?.systemSize}</li>
                            <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{formatDate(selectedBomDetails?.Date)}</li>
                            <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{selectedBomDetails?.TypesOfProject}</li>
                        </ul>
                    </div>

                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', width: '130px' }}>Category</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', width: '130px' }}>Sub Category</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', width: '150px' }}>Product</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', width: '150px' }}>Description</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', width: '50px' }}>Quantity</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', width: '50px' }}>Price</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px', width: '50px' }}>Total</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {selectedBomDetails?.BomDetails?.map((bom, index) => (
                                <TableRow key={index}>
                                    <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                        {categories?.find(category => category._id === bom?.bomcategory)?.categoryName || bom?.bomcategory}
                                    </TableCell>
                                    <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                        {subcategories?.find(subcategory => subcategory._id === bom?.bomsubcategory)?.subCategoryName || bom?.bomsubcategory}
                                    </TableCell>
                                    <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                        {productData?.find(product => product._id === bom?.bomproduct)?.productName || bom?.bomproduct}
                                    </TableCell>
                                    <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                        {bom?.bomdescription}
                                    </TableCell>
                                    <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                        {bom?.bomqty}
                                    </TableCell>
                                    <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                        {bom?.bomlastprice}
                                    </TableCell>
                                    <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>
                                        {bom?.bomamount}
                                    </TableCell>
                                </TableRow>
                            ))
                            }
                        </TableBody>
                    </Table>

                    <Table sx={{ mt: 2 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}></TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Remarks</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>System Size</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Unit Price</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Amount</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Dealer Commission in KW</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.Remarks1}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.SystemSize1}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.unitprice1}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.Amount1}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Interest</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.Remarks2}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.SystemSize2}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.unitprice2}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.Amount2}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Service & Maintenance</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.Remarks3}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.SystemSize3}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.unitprice3}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.Amount3}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Profit in KW</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.Remarks4}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.systemSize}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.unitprice4}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.Amount4}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Net Meter, Stamp and MCB Charge</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.Remarks5}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.SystemSize5}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.unitprice5}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.Amount5}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Super Structure and Extra Cabel Charge</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.Remarks6}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.SystemSize6}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.unitprice6}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.Amount6}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>

                    <Table sx={{ mt: 2 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Total</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>GST</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>TotalAmount</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Subcidy</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>Price After Subcidy	</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.Total}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.GST}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.TotalAmount}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.subcidy}</TableCell>
                                <TableCell sx={{ border: `1px solid ${theme.palette.text.primary}`, fontSize: '14px' }}>{selectedBomDetails?.PriceAfterSubcidy}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} sx={{ color: theme.palette.text.primary }}>Close</Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default BillofMaterial
